export function groupElementsByConnections(elements: Array<{ id: number; slaveId: number }>) {
  const groups = [];
  const idToGroupMap = new Map();

  elements.forEach(element => {
    const { id, slaveId } = element;

    const group = idToGroupMap.get(id) || idToGroupMap.get(slaveId) || [];
    group.push(element);

    idToGroupMap.set(id, group);
    idToGroupMap.set(slaveId, group);

    if (!groups.includes(group)) {
      groups.push(group);
    }
  });

  return groups;
}
